import CharacterMessageSwitcher from "../CharacterMessageSwitcher";
import MediaMessage from "../MediaMessage";
import NarratorMessage from "../NarratorMessage";
import ServiceMessage from "../ServiceMessage";

const AllMessageSwitcher = (props) => {
  const {
    message = {},
    onUnblurClick = () => { },
    onZoomClick = () => { },
    isShowVideoAvatar = false,
    videoAvatarUrl = '',
    setVideoModalState = () => { },
    scenario = {},
    topRightComponent = null,
    game = {},
    dialog = {},
  } = props;

  const { type = 'text' } = message;
  if (type === 'character') {
    return (
      <div>
        <CharacterMessageSwitcher
          message={message}
          topRightComponent={topRightComponent}
          onZoomClick={onZoomClick}
          isShowVideoAvatar={isShowVideoAvatar}
          videoAvatarUrl={videoAvatarUrl}
        />
      </div>
    );
  }
  if (type === 'narrator') {
    return (
      <div>
        <NarratorMessage
          message={message}
          onZoomClick={onZoomClick}
          setVideoModalState={setVideoModalState}
          topRightComponent={topRightComponent} />
      </div>
    );
  }
  if (type === 'media') {
    return <MediaMessage
      message={message}
      onUnblurClick={onUnblurClick}
      onZoomClick={onZoomClick}
      setVideoModalState={setVideoModalState}
      scenario={scenario}
      game={game}
      dialog={dialog}
    />;
  }
  if (type === 'service') {
    return <ServiceMessage message={message} />;
  }

  return <div className={'message_placeholder'}></div>;
};

export default AllMessageSwitcher;